import { render, staticRenderFns } from "./ApprovalTable.vue?vue&type=template&id=07a6d512&scoped=true&"
import script from "./ApprovalTable.vue?vue&type=script&lang=js&"
export * from "./ApprovalTable.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalTable.vue?vue&type=style&index=0&id=07a6d512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a6d512",
  null
  
)

export default component.exports